import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {Invoice} from '../../../../shared/interface/invoice';
import {InvoiceService} from '../../../../shared/services/invoice.service';
import {CommissionSettlement} from "../../../../shared/interface/commission-settlement";

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss']
})
export class InvoiceDetailsComponent implements OnInit, OnDestroy {
  invoiceId?: number = null;
  invoice: ReplaySubject<Invoice> = new ReplaySubject(1);
  invoiceObject?: Invoice = null;
  commissionSettlement: CommissionSettlement[] = [];
  contract: string;
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoiceService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.invoiceId = params.id;
        this.loadInvoice();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadInvoice(): void {
    this.invoiceService.get(this.invoiceId).subscribe((invoice: Invoice) => {
      this.invoice.next(invoice);
      invoice.settlements.forEach((settlements) => {
        this.commissionSettlement.push(settlements.contractSettlement.commissionSettlement);
        this.contract = settlements.contractSettlement.contract.uuid;
      });
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych faktury', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/faktury']);
    });
  }

}
